import { render } from "./newStockAllocationForm.vue?vue&type=template&id=5af8317b&scoped=true"
import script from "./newStockAllocationForm.vue?vue&type=script&lang=js"
export * from "./newStockAllocationForm.vue?vue&type=script&lang=js"

import "./newStockAllocationForm.vue?vue&type=style&index=0&id=5af8317b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af8317b"]])

export default __exports__